// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Icon } from '@zapier/common-components';

import Button from 'app/common/components/Button';

type DismissProps = {
  'aria-controls'?: string,
  'aria-describedby'?: string,
  'aria-disabled'?: boolean,
  'aria-expanded'?: boolean,
  'aria-label': string,
  'aria-labelledby'?: string,
  className?: string,
  iconSize?: number,
  onDismiss: () => void,
};

const Dismiss = (props: DismissProps) => {
  return (
    <Button
      aria-controls={props['aria-controls']}
      aria-describedby={props['aria-describedby']}
      aria-disabled={props['aria-disabled']}
      aria-expanded={props['aria-expanded']}
      aria-label={props['aria-labelledby'] ? undefined : props['aria-label']}
      aria-labelledby={props['aria-labelledby']}
      className={props.className}
      kind="as-text"
      onClick={props.onDismiss}
    >
      <Icon color="steel" name="delete" size={props.iconSize} />
    </Button>
  );
};

Dismiss.defaultProps = {
  'aria-label': 'Close',
  className: '',
  iconSize: 10,
};

export default Dismiss;
